
// You can write more code here

/* START OF COMPILED CODE */

import ChunkBase from "../../ChunkBase";
import ChunkBoundaries from "../../../components/ChunkBoundaries";
import BoundsMarker from "../../editor/BoundsMarker";
import DecorationTrunk from "../../decorations/jungle/DecorationTrunk";
import PlatformMarkerFoliage3 from "../../editor/platform-markers/jungle/PlatformMarkerFoliage3";
import SmallGemMarker from "../../editor/entity-markers/SmallGemMarker";
import SmashableMarkerVine from "../../editor/entity-markers/SmashableMarkerVine";
import SimpleBreakableBlocker from "../../../components/platformer/SimpleBreakableBlocker";
import PlatformMarkerFoliage4 from "../../editor/platform-markers/jungle/PlatformMarkerFoliage4";
import PlatformFoliage1 from "../../platforms/jungle/PlatformFoliage1";
import PlatformFoliage2 from "../../platforms/jungle/PlatformFoliage2";
import RelicMarker from "../../editor/RelicMarker";
import CheckpointMarker from "../../editor/CheckpointMarker";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class JungleChunkRelic1 extends ChunkBase {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 341, y ?? 108);

    // editor_bounds_right
    const editor_bounds_right = new BoundsMarker(scene, 5228, 661);
    this.add(editor_bounds_right);

    // editor_bounds_left
    const editor_bounds_left = new BoundsMarker(scene, -331, 661);
    this.add(editor_bounds_left);

    // trunk_png_1
    const trunk_png_1 = new DecorationTrunk(scene, 2278, 799);
    this.add(trunk_png_1);

    // trunk_png_2
    const trunk_png_2 = new DecorationTrunk(scene, -86, 808);
    this.add(trunk_png_2);

    // trunk_png
    const trunk_png = new DecorationTrunk(scene, 487, 585);
    this.add(trunk_png);

    // platformMarkerFoliage_1
    const platformMarkerFoliage_1 = new PlatformMarkerFoliage3(scene, 2266, 38);
    this.add(platformMarkerFoliage_1);

    // gemMarker_11
    const gemMarker_11 = new SmallGemMarker(scene, 908, 72);
    this.add(gemMarker_11);

    // smashableMarkerVine
    const smashableMarkerVine = new SmashableMarkerVine(scene, 1325, -95);
    this.add(smashableMarkerVine);

    // platformMarkerFoliage4
    const platformMarkerFoliage4 = new PlatformMarkerFoliage4(scene, 955, 594);
    this.add(platformMarkerFoliage4);

    // platformFoliage1
    const platformFoliage1 = new PlatformFoliage1(scene, 1341, -243);
    this.add(platformFoliage1);

    // platformFoliage2
    const platformFoliage2 = new PlatformFoliage2(scene, 491, 279);
    this.add(platformFoliage2);

    // platformFoliage
    const platformFoliage = new PlatformFoliage1(scene, 1772, 60);
    this.add(platformFoliage);

    // trunk_png_4
    const trunk_png_4 = new DecorationTrunk(scene, 959, 903);
    this.add(trunk_png_4);

    // trunk_png_5
    const trunk_png_5 = new DecorationTrunk(scene, 4705, 767);
    this.add(trunk_png_5);

    // trunk_png_7
    const trunk_png_7 = new DecorationTrunk(scene, 1604, 892);
    this.add(trunk_png_7);

    // platformMarkerFoliage_3
    const platformMarkerFoliage_3 = new PlatformMarkerFoliage4(scene, 1620, 578);
    this.add(platformMarkerFoliage_3);

    // gemMarker
    const gemMarker = new SmallGemMarker(scene, 1783, -41);
    this.add(gemMarker);

    // gemMarker_1
    const gemMarker_1 = new SmallGemMarker(scene, 4703, 338);
    this.add(gemMarker_1);

    // gemMarker_4
    const gemMarker_4 = new SmallGemMarker(scene, 491, 192);
    this.add(gemMarker_4);

    // gemMarker_6
    const gemMarker_6 = new SmallGemMarker(scene, 4287, 84);
    this.add(gemMarker_6);

    // platformMarkerFoliage_5
    const platformMarkerFoliage_5 = new PlatformMarkerFoliage3(scene, 3900, -60);
    this.add(platformMarkerFoliage_5);

    // gemMarker_7
    const gemMarker_7 = new SmallGemMarker(scene, 3893, -173);
    this.add(gemMarker_7);

    // platformMarkerFoliage_6
    const platformMarkerFoliage_6 = new PlatformMarkerFoliage4(scene, -68, 496);
    this.add(platformMarkerFoliage_6);

    // smashableMarkerVine_1
    const smashableMarkerVine_1 = new SmashableMarkerVine(scene, 2278, -166);
    this.add(smashableMarkerVine_1);

    // platformMarkerFoliage
    const platformMarkerFoliage = new PlatformMarkerFoliage4(scene, 2267, -331);
    this.add(platformMarkerFoliage);

    // smashableMarkerVine_2
    const smashableMarkerVine_2 = new SmashableMarkerVine(scene, 3244, -339);
    this.add(smashableMarkerVine_2);

    // platformMarkerFoliage_7
    const platformMarkerFoliage_7 = new PlatformMarkerFoliage4(scene, 2981, 511);
    this.add(platformMarkerFoliage_7);

    // trunk_png_9
    const trunk_png_9 = new DecorationTrunk(scene, 2985, 820);
    this.add(trunk_png_9);

    // gemMarker_9
    const gemMarker_9 = new SmallGemMarker(scene, 2760, -127);
    this.add(gemMarker_9);

    // platformMarkerFoliage_8
    const platformMarkerFoliage_8 = new PlatformMarkerFoliage3(scene, 3218, -489);
    this.add(platformMarkerFoliage_8);

    // relicMarker
    const relicMarker = new RelicMarker(scene, 3419, -227);
    this.add(relicMarker);

    // platformMarkerFoliage_4
    const platformMarkerFoliage_4 = new PlatformMarkerFoliage4(scene, 3305, -104);
    this.add(platformMarkerFoliage_4);

    // platformMarkerFoliage_9
    const platformMarkerFoliage_9 = new PlatformMarkerFoliage3(scene, 1335, 112);
    this.add(platformMarkerFoliage_9);

    // platformMarkerFoliage_10
    const platformMarkerFoliage_10 = new PlatformMarkerFoliage3(scene, 2278, 499);
    this.add(platformMarkerFoliage_10);

    // platformFoliage_1
    const platformFoliage_1 = new PlatformFoliage1(scene, 2755, -25);
    this.add(platformFoliage_1);

    // platformMarkerFoliage_2
    const platformMarkerFoliage_2 = new PlatformMarkerFoliage4(scene, 4709, 447);
    this.add(platformMarkerFoliage_2);

    // trunk_png_3
    const trunk_png_3 = new DecorationTrunk(scene, 3569, 817);
    this.add(trunk_png_3);

    // platformFoliage_2
    const platformFoliage_2 = new PlatformFoliage2(scene, 3573, 510);
    this.add(platformFoliage_2);

    // platformFoliage_3
    const platformFoliage_3 = new PlatformFoliage2(scene, 4277, 179);
    this.add(platformFoliage_3);

    // platformFoliage_4
    const platformFoliage_4 = new PlatformFoliage1(scene, 904, 160);
    this.add(platformFoliage_4);

    // checkpointMarker
    const checkpointMarker = new CheckpointMarker(scene, -235, 433);
    this.add(checkpointMarker);

    // checkpointMarker_1
    const checkpointMarker_1 = new CheckpointMarker(scene, 2829, 437);
    this.add(checkpointMarker_1);

    // gemMarker_12
    const gemMarker_12 = new SmallGemMarker(scene, 1401, 35);
    this.add(gemMarker_12);

    // gemMarker_13
    const gemMarker_13 = new SmallGemMarker(scene, 1454, -7);
    this.add(gemMarker_13);

    // gemMarker_30
    const gemMarker_30 = new SmallGemMarker(scene, 1399, -41);
    this.add(gemMarker_30);

    // trunk_png_6
    const trunk_png_6 = new DecorationTrunk(scene, 4048, 729);
    this.add(trunk_png_6);

    // platformMarkerFoliage_11
    const platformMarkerFoliage_11 = new PlatformMarkerFoliage3(scene, 4048, 429);
    this.add(platformMarkerFoliage_11);

    // gemMarker_2
    const gemMarker_2 = new SmallGemMarker(scene, 2358, -40);
    this.add(gemMarker_2);

    // gemMarker_3
    const gemMarker_3 = new SmallGemMarker(scene, 2411, -82);
    this.add(gemMarker_3);

    // gemMarker_5
    const gemMarker_5 = new SmallGemMarker(scene, 2356, -116);
    this.add(gemMarker_5);

    // this (components)
    new ChunkBoundaries(this);

    // smashableMarkerVine (components)
    const smashableMarkerVineSimpleBreakableBlocker = SimpleBreakableBlocker.getComponent(smashableMarkerVine);
    smashableMarkerVineSimpleBreakableBlocker.allowedCharacter = "panda";

    // smashableMarkerVine_1 (components)
    const smashableMarkerVine_1SimpleBreakableBlocker = SimpleBreakableBlocker.getComponent(smashableMarkerVine_1);
    smashableMarkerVine_1SimpleBreakableBlocker.allowedCharacter = "ice";

    // smashableMarkerVine_2 (components)
    const smashableMarkerVine_2SimpleBreakableBlocker = SimpleBreakableBlocker.getComponent(smashableMarkerVine_2);
    smashableMarkerVine_2SimpleBreakableBlocker.allowedCharacter = "grizz";
    // awake handler
    this.scene.events.once("scene-awake", () => this.awake());

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  // Write your code here.

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
